import Image from 'next/image';

import { getImage } from '@/components/CrossChainSwaps/UserProfilesSection';

import { StyledH2, StyledPrimaryCell } from '../utils';

const tradersItems = [
  {
    url: getImage(1),
    label: 'Treasury managers',
  },
  {
    url: getImage(3),
    label: 'Day traders',
  },
  {
    url: getImage(4),
    label: 'Investment funds',
  },
  {
    url: getImage(5),
    label: 'Traders moving large amounts',
  },
];

export function TradersControlSection() {
  return (
    <StyledPrimaryCell className="flex-col pt-16 pb-8.5 tablet:pb-16 desktop:pb-13.5 px-8 bg-gray-95 bg-[url(/images/limit-orders/wave-lines-mobile.svg)] bg-no-repeat bg-bottom tablet:bg-[url(/images/limit-orders/wave-lines.svg)]">
      <StyledH2 className="block py-2 text-center">
        For traders who
        <span className="text-token-gray-1000"> want price control and execution</span>
      </StyledH2>

      <ul className="flex flex-wrap tablet:flex-nowrap justify-evenly tablet:justify-around mt-10.5 tablet:mt-18">
        {tradersItems.map(({ url, label }, index) => (
          <li
            key={label}
            className={`flex flex-col items-center px-2 my-7.5 flex-[0_0_50%] min-w-[134px] max-w-[162px] tablet:flex-none tablet:my-0 ${index === 0 ? 'tablet:mt-12' : ''} ${index === tradersItems.length - 1 ? 'tablet:mt-6' : ''}`}
          >
            <Image
              src={url}
              alt=""
              height={73}
              width={73}
              className="stroke-token-gray-600 [filter:drop-shadow(0px_4px_42px_rgba(0,0,0,0.06))_drop-shadow(0px_5px_6px_rgba(0,0,0,0.08))] transform-gpu"
            />
            <span className="text-center mt-4 text-token-gray-800 leading-6">{label}</span>
          </li>
        ))}
      </ul>
    </StyledPrimaryCell>
  );
}
